
import Component from 'vue-class-component';
import Vue from 'vue';

@Component({ props: { name: String } })
export default class checkboxGroup extends Vue {}
